module.exports = __webpack_public_path__ + "static/img/4d.533e377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/4d.jpg
// module id = 9gms
// module chunks = 0